var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcArrivalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 31,
    viewBox: "0 0 49 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_31_10681)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 0.5,
    width: 41,
    height: 22,
    rx: 11,
    fill: "#2297FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9794 5.91406V10.0859H24.5497V11.3164H22.9794V16.5781H21.5028V5.91406H22.9794ZM14.5067 8.70312V7.50781H16.9208V6.07812H18.4208V7.50781H20.7762V8.70312H14.5067ZM14.9403 11.8438C14.9345 10.3555 16.0946 9.29492 17.6708 9.30078C19.2235 9.29492 20.3895 10.3555 20.3895 11.8438C20.3895 13.332 19.2235 14.3809 17.6708 14.3867C16.0946 14.3809 14.9345 13.332 14.9403 11.8438ZM16.37 11.8438C16.37 12.6699 16.9149 13.1621 17.6708 13.1562C18.4149 13.1621 18.9598 12.6699 18.9598 11.8438C18.9598 11.0234 18.4149 10.5195 17.6708 10.5078C16.9149 10.5195 16.37 11.0234 16.37 11.8438ZM28.5519 9.25391C28.5519 10.7715 29.337 12.4824 31.0363 13.2852L30.2042 14.4102C29.0616 13.8945 28.2706 12.8926 27.8253 11.7031C27.3624 12.9863 26.5245 14.0645 25.3175 14.5977L24.4972 13.4375C26.2374 12.6699 27.0636 10.8535 27.0753 9.25391V8.84375H24.8722V7.64844H27.0636V6.14844H28.5636V7.64844H30.7316V8.84375H28.5519V9.25391ZM31.6105 16.5781V5.91406H33.1105V10.0508H34.6808V11.3047H33.1105V16.5781H31.6105Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_31_10681",
    x: 0,
    y: 0.5,
    width: 49,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_31_10681"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_31_10681",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrivalIcon);
export default __webpack_public_path__ + "static/media/ic_arrival_icon.3956729135c09d0ea4377df07754ba2d.svg";
export { ForwardRef as ReactComponent };